import { BrowserRouter } from 'react-router-dom';

import { AppHeader } from '@/components/layout/AppHeader/AppHeader';
import { AppFooter } from '@/components/layout/AppFooter/AppFooter';
import { PageContainer } from '@/components/layout/PageContainer/PageContainer';
import { BrowserQueryCacheProvider } from '@/lib/query-cache/query-cache-provider';
import { PositionsFlowProvider } from '@/hooks/usePositionsFlow';
import { PoliticalMatchFlowProvider } from '@/hooks/usePoliticalMatchFlow';

import { AppRouter } from './router';

import styles from '@/styles/layout.module.css';

export function App(): JSX.Element {
  return (
    <BrowserQueryCacheProvider>
      <PoliticalMatchFlowProvider>
        <PositionsFlowProvider>
          <BrowserRouter>
            <div className={styles.pageShell}>
              <AppHeader />
              <main className={styles.main}>
                <PageContainer>
                  <AppRouter />
                </PageContainer>
              </main>
              <AppFooter />
            </div>
          </BrowserRouter>
        </PositionsFlowProvider>
      </PoliticalMatchFlowProvider>
    </BrowserQueryCacheProvider>
  );
}
